import { render, staticRenderFns } from "./NavegacionModalCrud.vue?vue&type=template&id=6f0c9bc1&"
import script from "./NavegacionModalCrud.vue?vue&type=script&lang=ts&"
export * from "./NavegacionModalCrud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports